__turbopack_context__.v({
  "address": "TransactionsPage-module__PT4F3W__address",
  "addressGroup": "TransactionsPage-module__PT4F3W__addressGroup",
  "addressRow": "TransactionsPage-module__PT4F3W__addressRow",
  "age": "TransactionsPage-module__PT4F3W__age",
  "arrow": "TransactionsPage-module__PT4F3W__arrow",
  "badge": "TransactionsPage-module__PT4F3W__badge",
  "checkbox": "TransactionsPage-module__PT4F3W__checkbox",
  "controls": "TransactionsPage-module__PT4F3W__controls",
  "copyButton": "TransactionsPage-module__PT4F3W__copyButton",
  "emptyState": "TransactionsPage-module__PT4F3W__emptyState",
  "fee": "TransactionsPage-module__PT4F3W__fee",
  "filterButton": "TransactionsPage-module__PT4F3W__filterButton",
  "icon": "TransactionsPage-module__PT4F3W__icon",
  "link": "TransactionsPage-module__PT4F3W__link",
  "method": "TransactionsPage-module__PT4F3W__method",
  "pageButton": "TransactionsPage-module__PT4F3W__pageButton",
  "pageButtonActive": "TransactionsPage-module__PT4F3W__pageButtonActive",
  "pagination": "TransactionsPage-module__PT4F3W__pagination",
  "rightControls": "TransactionsPage-module__PT4F3W__rightControls",
  "scanning": "TransactionsPage-module__PT4F3W__scanning",
  "scanningRow": "TransactionsPage-module__PT4F3W__scanningRow",
  "shimmer": "TransactionsPage-module__PT4F3W__shimmer",
  "skeleton": "TransactionsPage-module__PT4F3W__skeleton",
  "statCard": "TransactionsPage-module__PT4F3W__statCard",
  "statLabel": "TransactionsPage-module__PT4F3W__statLabel",
  "statTime": "TransactionsPage-module__PT4F3W__statTime",
  "statValue": "TransactionsPage-module__PT4F3W__statValue",
  "statsGrid": "TransactionsPage-module__PT4F3W__statsGrid",
  "statusSuccess": "TransactionsPage-module__PT4F3W__statusSuccess",
  "tab": "TransactionsPage-module__PT4F3W__tab",
  "tabActive": "TransactionsPage-module__PT4F3W__tabActive",
  "table": "TransactionsPage-module__PT4F3W__table",
  "tableContainer": "TransactionsPage-module__PT4F3W__tableContainer",
  "tabs": "TransactionsPage-module__PT4F3W__tabs",
  "value": "TransactionsPage-module__PT4F3W__value",
});
